import {
  FETCH_DASHBOARD_LOADING,
  FETCH_DASHBOARD_SUCCESS,
  FETCH_DASHBOARD_FAILURE
} from '../Types/missionTypes';

const initState = {
  data: [],
  error: null,
  success: null,
  loading: false
};

const dashboardReducer = function (state = initState, action) {
  switch (action.type) {
    case FETCH_DASHBOARD_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
        success: null,
        data: []
      };

    case FETCH_DASHBOARD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        success: null,
        data: action.payload
      };

    case FETCH_DASHBOARD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: null,
        data: []
      };

    default:
      return { ...state };
  }
};

export default dashboardReducer;
